import type { Parser, Values } from "nuqs";
import { dataLayerPush } from "./data-layer-push";

let lastFilterValueItems = new Set();

export function trackingOnFilterChange(
  newFilter: Values<{
    [x: string]: Parser<string>;
  }>
) {
  // Convert filter values to tracking format (key:value)
  const filterValueItems = Object.entries(newFilter)
    .flatMap(([key, value]) => {
      const vals = value?.split(",");
      return vals?.map((v) => `${key}:${v}`);
    })
    .filter(Boolean);
  const newFilterValueItems = filterValueItems.filter(
    (fvi) => !lastFilterValueItems.has(fvi)
  );

  // Push an GTM dataLayer event for each new filter
  for (const newFilterValueItem of newFilterValueItems) {
    const filterType = newFilterValueItem?.split(":")[0];
    dataLayerPush({
      event: "jobboard_filter_used",
      // Technically we call a FilterValue something like "language: German OR English" and a
      // FilterValueItem something like "language: German".
      // For tracking purposes, we'll only use the FilterValueItem
      filterValue: newFilterValueItem,
      filterType,
      filterValues: String(filterValueItems),
    });
  }

  lastFilterValueItems = new Set(filterValueItems);
}
